import { configureStore } from "@reduxjs/toolkit";
import commonSlice from "./commonSlice";
import authSlice from "../modules/Authentication/features/authSlice";
import kpiSlice from "../modules/KPI/features/kpiSlice";
import pulseSlice from "../modules/Pulse/features/pulseSlice";

const store = configureStore({
  reducer: {
    auth: authSlice,
    common: commonSlice,
    kpi: kpiSlice,
    pulse: pulseSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  devTools: true,
});

export default store;
